import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu_icons/Utilizatori.png'


const _withScopeId = n => (_pushScopeId("data-v-4483e742"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ecran-container",
  style: {"min-height":"75vh"}
}
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = { class: "app__color--label q-ma-md" }
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","margin-right":"4px","width":"28px","height":"24px"}
}, null, -1))
const _hoisted_6 = { class: "dashboard__div__content app__border__bottom" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute-full flex flex-center bg-negative text-white text-subtitle2" }, " No Image ", -1))
const _hoisted_8 = {
  class: "dashboard__div__parameter",
  style: {"grid-area":"nume"}
}
const _hoisted_9 = { class: "app__property--medium" }
const _hoisted_10 = {
  class: "dashboard__div__parameter",
  style: {"grid-area":"prenume"}
}
const _hoisted_11 = { class: "app__property--medium" }
const _hoisted_12 = {
  class: "dashboard__div__parameter",
  style: {"grid-area":"telefon"}
}
const _hoisted_13 = {
  class: "dashboard__div__parameter email",
  style: {"grid-area":"email"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$q.platform.is.desktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.users')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "dashboard__section",
        key: user.appid
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_q_avatar, {
            size: "7rem",
            style: {"grid-area":"avatar","margin-right":"1rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_img, {
                src: user.urlUserImgProfileByAppid,
                style: {"height":"7rem","max-width":"7rem"}
              }, {
                error: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["src"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(user.firstName), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(user.lastName), 1)
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(user.phoneNr), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(user.email), 1)
        ])
      ]))
    }), 128))
  ]))
}